<template>
  <div class="md-example-child md-example-child-selector md-example-child-selector-1">
    <md-selector
      v-bind="$attrs"
      max-height="320px"
      large-radius
      :title="$t('change_bank/card')"
      :cancel-text="' '"
      is-check
      :mask-closable="false"
      :default-value="bankInfo.bankNo"
      v-on="$listeners"
      @choose="onSelectorChoose"
    >
      <template slot-scope="{ option, selected }">
        <div class="selector-item-body" :class="{disabled: option.disabled, selected}">
          <div class="selector-item-left">
            <span class="holder">
              <img
                v-if="option.bankNo"
                class="icon_svg"
                :src="getIconByCode(option.bankNo)"
                alt="bank-icon"
              >
            </span>
          </div>
          <div class="selector-item-content">
            <p class="selector-item-title" v-text="option.bankShortName" />
          </div>
        </div>
      </template>
    </md-selector>
  </div>
</template>

<script>
import { Selector, Field, FieldItem, Icon, CellItem } from 'mand-mobile'
import { getIconByCode } from '@flash/fin-logo'
export default {
  name: 'BankList',
  components: {
    [Selector.name]: Selector,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [Icon.name]: Icon,
    [CellItem.name]: CellItem
  },
  props: {
    bankInfo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      getIconByCode
    }
  },
  methods: {
    onSelectorChoose (option) {
      this.$emit('selectBank', option)
    },
    addCardHandle () {
      // 跳转到绑定新卡页面
      this.$router.push({ name: 'CardSelectType' })
    }
  }
}

</script>

<style lang="scss" scoped>
.md-example-child-selector-1 {
  .selector-header,
  .selector-footer {
    padding: 15px 20px;
    font-size: 16px;
    color: #ccc;
  }

  .selector-item-body {
    display: flex;
    align-items: center;

    &.selected {
      .selector-item-content {
        color: #2f86f6;
      }
    }

    &.disabled {
      opacity: 0.3;
    }

    .selector-item-left {
      flex-shrink: 0;
      margin-right: 32px;
    }
    /* stylelint-disable no-descending-specificity, declaration-block-no-duplicate-properties,  selector-pseudo-element-no-unknown, font-family-no-missing-generic-family-keyword */

    .selector-item-content {
      flex: 1;
      color: #111a34;
      font-size: 32px;
      line-height: 1.2;

      .selector-item-title {
        line-height: 1.2;
      }

      .selector-item-brief {
        color: #858b9c;
        font-size: 24px;
        line-height: 1.4;
        margin-top: 8px;
      }
    }
  }
}

.selector-header {
  display: flex;
  align-items: center;
  margin: 50px 0 0 0;
  transform: translate3d(0, 0, 0);

  div {
    flex: 1;
    display: flex;
    justify-content: center;
    font-size: 32px;
    font-weight: 500;
    color: #333;
  }
}

.md-icon.icon-font.lg {
  color: #333;
}

.md-example-child-selector-1 .selector-header[data-v-d3c17fea],
.md-example-child-selector-1 .selector-footer[data-v-d3c17fea] {
  padding: 0;
}

.holder {
  display: block;
  width: 64px;
  height: 64px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon_svg {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.round-button {
  width: 64px;
  height: 64px;
  border-radius: 100%;
  border: none;
  background-color: #f7f7f7;
  font-size: 50px;
  outline: none;
}

::v-deep .title-bar-left::before {
  font-family: Mand-Mobile-Icon !important;
  content: "\E604";
}

::v-deep .md-selector-list {
  margin-top: 24px;
}
/* stylelint-enable */
</style>
